var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container--reset-padding",class:{'spacer': _vm.numResults < 1}},[(_vm.numResults > 0)?_c('p',[_vm._v(_vm._s(_vm.i18n_strings.verified_desc))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }